export class InvalidGovernment {
	constructor(
		public id: string,
		public type: InvalidGovernmentType) {}
}

export enum InvalidGovernmentType {
	noGovernmentForProvidedCode = 'noGovernmentForProvidedCode',
}
